export default __webpack_public_path__ + "static/media/logo14.80d791fa.png";